import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@svenskaspelab/ui/react/tooltip';
import { useState } from 'react';
import ShareButtonAlternatives from './ShareButtonAlternatives.js';
/**
 * This component renders a button for sharing the current coupon.
 *
 * @param root0 the input props
 * @param root0.isDisabled the status of the current coupon
 * @param root0.url the url to share
 * @param root0.className additional class names for the button
 * @param root0.text the text to display on the button, defaults to "Dela kupong"
 * @param root0.variant the variant of the button, defaults to "outline"
 * @param root0.onClick the onClick handler for the button
 * @returns the share coupon button
 */
export default function ShareButton(t0) {
  const $ = _c(12);
  const {
    isDisabled,
    url,
    className,
    text,
    variant,
    onClick
  } = t0;
  const [shareStatus, setShareStatus] = useState("None");
  let t1;
  if ($[0] !== shareStatus) {
    t1 = () => {
      if (shareStatus === "CopiedToClipboard") {
        setTimeout(() => {
          setShareStatus("None");
        }, 2000);
      }
    };
    $[0] = shareStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleTippyShown = t1;
  let t2;
  let t3;
  if ($[2] !== className || $[3] !== handleTippyShown || $[4] !== isDisabled || $[5] !== onClick || $[6] !== shareStatus || $[7] !== text || $[8] !== url || $[9] !== variant) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const shareButton = _jsx(ShareButtonAlternatives, {
        isDisabled,
        shareStatus,
        setShareStatus,
        url,
        className,
        text,
        variant,
        onClick
      });
      if (shareStatus === "Text") {
        t3 = shareButton;
        break bb0;
      }
      t2 = _jsx(TooltipProvider, {
        children: _jsxs(Tooltip, {
          open: shareStatus === "CopiedToClipboard",
          onOpenChange: handleTippyShown,
          children: [_jsx(TooltipTrigger, {
            render: shareButton
          }), _jsx(TooltipContent, {
            sideOffset: 0,
            side: "bottom",
            children: "L\xE4nken \xE4r kopierad, dela den med dina v\xE4nner"
          })]
        })
      });
    }
    $[2] = className;
    $[3] = handleTippyShown;
    $[4] = isDisabled;
    $[5] = onClick;
    $[6] = shareStatus;
    $[7] = text;
    $[8] = url;
    $[9] = variant;
    $[10] = t2;
    $[11] = t3;
  } else {
    t2 = $[10];
    t3 = $[11];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
}